import styled from 'styled-components';
import Theme from '../../../styles/models/theme';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const ChatInputContainer = styled.div<{theme: Theme}>`
  background: ${({theme}) => theme.white};
  border: 1px solid ${({theme}) => theme.grayBorder};
  box-sizing: border-box;
  border-radius: 100px;
  flex: 1;
  padding-left: 8px;
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  align-items: center;
`;

export const InputField = styled.input<{
  type: string;
  placeholder: string;
  theme: Theme;
}>`
  font-size: 18px;
  outline: none;
  background: #00000000;
  border: 0px;
  padding: 5px;
  flex: 1;
  ::placeholder {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${({theme}) => theme.grayBorder};
  }
`;

export const InputLabel = styled.text`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  text-align: left;
  color: #00234d;
  margin-left: 10px;
  margin-top: 20px;
`;

export const HelperText = styled.img`
  position: relative;
  top: -47px;
  left: 78vw;
  height: 0px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: ${({theme}) => theme.inputPlaceholder};
`;
